import { useState, useEffect, useContext, Fragment } from 'react';
import { getContestants, getJudges, setTopContestants } from '../utils/firebase';
import { UserContext } from "../context/user-context";
import { useParams, useNavigate } from 'react-router-dom'
import ResultsPreliminariesItem from '../components/results-preliminaries-item';
import html2canvas from 'html2canvas';
import { categories, getCategoryPercentage, getCategoryName, title } from '../utils/utils';

const RankingPreliminaries = () => {
    const [list, setList = () => []] = useState([]);
    const [judges, setJudges = () => []] = useState([]);
    const { currentUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        async function getDocs() {
            const docs = await getContestants("Contestants", "score");
            setList(docs);
        };
        getDocs();
    }, []);

    useEffect(() => {
        async function getDocs() {
            const docs = await getJudges();
            setJudges(docs);
        };
        getDocs();
    }, []);

    const onClickHandler = async() => {
        if (selected.length < 10) {
            alert("select 10 contestants");
            return;
        }

        const response = await setTopContestants("Top10", selected);
        if (response === "success") {
            navigate("/results/top10");
        } else {
            alert(response);
        }
    }

    const onItemAddHandler = async(item) => {
        const existing = selected.find((sel) => sel.id === item.id);
        if (existing) {
            setSelected(selected.filter((sel) => {return sel.id !== item.id}));
            return;
        }

        if (selected.length >= 10) {
            return;
        }

        selected.push(item);
        setSelected([...selected]);
    }

    const onPrintHandler = () => {
        var printContents = document.getElementById("print");
    
        html2canvas(printContents, {scale: 3}).then(function(canvas) {
          var myImage = canvas.toDataURL('image/png');
    
          var mywindow = window.open('PRINT');
    
          mywindow.document.write('<html><head><title>' + document.title  + '</title>');
          mywindow.document.write('</head><body >');
          mywindow.document.write('<img src="' + myImage + '" style="width: 100%"/>');
          mywindow.document.write('</body></html>');
      
          setTimeout(() => {
            mywindow.document.close();
            mywindow.focus();
        
            mywindow.print();
            mywindow.close();
          }, 10)
        })
      }

    return (
        <div className='column is-12'>
            <div id='print'>
            <p className='is-size-4 has-text-centered'>Preliminaries</p>
            <h1 className='is-size-1 has-text-weight-bold has-text-centered mb-6'>{title}</h1>

            <div className="table-container mt-6">
                <table className="table is-fullwidth is-hoverable is-bordered has-text-centered is-selectable">
                    <thead>
                        <tr className='has-text-vcentered'>
                            <th rowSpan="3">#</th>
                            <th rowSpan="3">Name</th>
                            <th colSpan="22">Judges</th>
                            {categories.map((category, index) => {
                                return (
                                    <th key={index + "_" + category} rowSpan="2" colSpan="3">{category}<br/><small>{getCategoryName(category)}<br/>({getCategoryPercentage(category)}%)</small></th>
                                );
                            })}
                            <th rowSpan="3">Score</th>
                            <th rowSpan="3">Rank</th>
                        </tr>

                        <tr>
                            <th colSpan="4">1</th>
                            <th colSpan="4">2</th>
                            <th colSpan="4">3</th>
                            <th colSpan="4">4</th>
                            <th colSpan="4">5</th>
                            <th colSpan="2">6</th>
                        </tr>

                        <tr>
                            <td>C1</td>
                            <td>C2</td>
                            <td>C3</td>
                            <td>C4</td>
                            <td>C1</td>
                            <td>C2</td>
                            <td>C3</td>
                            <td>C4</td>
                            <td>C1</td>
                            <td>C2</td>
                            <td>C3</td>
                            <td>C4</td>
                            <td>C1</td>
                            <td>C2</td>
                            <td>C3</td>
                            <td>C4</td>
                            <td>C1</td>
                            <td>C2</td>
                            <td>C3</td>
                            <td>C4</td>
                            <td>C1</td>
                            <td>C2</td>
                            {categories.map((category, index) => {
                                return (
                                    <Fragment key={index + "_" + category + "_data"}>
                                        <th>T</th>
                                        <th>A</th>
                                        <th>%</th>
                                    </Fragment>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((contestant, index) => {
                            var tie = 0;
                            for (let i = index - 1; i > -1; i--) {
                                if (list[i].score === contestant.score) {
                                    tie++;
                                }
                            }
                            const pos = index + 1 - tie;

                            const active = selected.find((sel) => sel.id === contestant.id);
                            return (
                                <ResultsPreliminariesItem contestant={contestant} rank={pos} key={contestant.id} onItemAddHandler={onItemAddHandler} active={active}/>
                            )
                        })}
                    </tbody>
                    </table>
                </div>

                <div className='columns my-6'>
                    {judges.map((judge, index) => {
                        return (
                            <div className='column is-one-fifth' key={judge.uid}><p className='has-text-centered has-text-weight-medium is-size-5' style={{borderBottom: "1px solid #dbdbdb"}}>{judge.name}</p><p className='has-text-centered'>{judge.uid.charAt(0).toUpperCase() + judge.uid.substring(1).toLowerCase()}</p></div>
                        )
                    })}
                </div>
                </div>
                    <button type="button" className="is-fullwidth button is-info block is-large column is-8 is-offset-2 mt-6" onClick={onPrintHandler}>Print</button>

                    <button type="button" className="is-fullwidth button is-danger block is-large column is-8 is-offset-2 mb-6" onClick={onClickHandler}>Generate Top 10</button>
        </div>
    )
}

export default RankingPreliminaries;